


(function($) {

	function setImageInitialClasses(el) {
		var that = $(el);

		that.addClass("portfolio-image")
	}

	function setImageWaypoint(el) {
		const waypoint = new Waypoint({
		    element: el,
			offset: '90%',
		    handler: (direction) => {
				$(el).addClass("portfolio-image--inview")
		    },
		});
	}


	function setAnimateWaypoint(el) {
		const waypoint = new Waypoint({
		    element: el,
			offset: '90%',
		    handler: (direction) => {
				$(el).addClass("animate-in")
		    },
		});
	}

	window.addEventListener("pageLoaded", function(event) {
		window.setTimeout(function() {

		    // Get all portfolio images in the content and set waypoints for them
			const portfolioImages = $("#portfolio-content img");

			$(portfolioImages).each(function(i, el) {
				setImageInitialClasses(el);
				setImageWaypoint(el);
			})


			const animatedItems = $(".waypoint-animated")

			$(animatedItems).each(function(i,el) {
				setAnimateWaypoint(el)
			})
		}, 200);
	});
	
	
	
})( jQuery );